import React from 'react';
import { Zap, Instagram, Facebook, Twitter, Mail } from 'lucide-react';

const Footer = ({ onNavigate }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-yellow-500 rounded-lg flex items-center justify-center">
                <Zap className="w-6 h-6 text-gray-900" />
              </div>
              <span className="text-2xl font-bold">JYA</span>
            </div>
            <p className="text-gray-400 leading-relaxed mb-6">
              La solution de location de batteries externes la plus simple et accessible. Restez toujours connecté.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-yellow-500 rounded-lg flex items-center justify-center transition-all duration-300 group">
                <Instagram className="w-5 h-5 text-gray-400 group-hover:text-gray-900" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-yellow-500 rounded-lg flex items-center justify-center transition-all duration-300 group">
                <Facebook className="w-5 h-5 text-gray-400 group-hover:text-gray-900" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-yellow-500 rounded-lg flex items-center justify-center transition-all duration-300 group">
                <Twitter className="w-5 h-5 text-gray-400 group-hover:text-gray-900" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Liens Rapides</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => onNavigate('hero')} className="text-gray-400 hover:text-yellow-500 transition-colors">
                  Accueil
                </button>
              </li>
              <li>
                <button onClick={() => onNavigate('how-it-works')} className="text-gray-400 hover:text-yellow-500 transition-colors">
                  Comment ça marche
                </button>
              </li>
              <li>
                <button onClick={() => onNavigate('locations')} className="text-gray-400 hover:text-yellow-500 transition-colors">
                  Nos lieux
                </button>
              </li>
              <li>
                <button onClick={() => onNavigate('pricing')} className="text-gray-400 hover:text-yellow-500 transition-colors">
                  Tarifs
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4">Services</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => onNavigate('partner')} className="text-gray-400 hover:text-yellow-500 transition-colors">
                  Devenir partenaire
                </button>
              </li>
              <li>
                <button onClick={() => onNavigate('locations')} className="text-gray-400 hover:text-yellow-500 transition-colors">
                  Trouver une borne
                </button>
              </li>
              <li>
                <button onClick={() => onNavigate('contact')} className="text-gray-400 hover:text-yellow-500 transition-colors">
                  Support client
                </button>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-yellow-500 transition-colors">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Mail className="w-5 h-5 text-yellow-500 flex-shrink-0 mt-0.5" />
                <a href="mailto:societejya@gmail.com" className="text-gray-400 hover:text-yellow-500 transition-colors">
                  societejya@gmail.com
                </a>
              </li>
              <li className="text-gray-400">
                64 Rue Belle de Mai<br />
                13003 Marseille, France
              </li>
              <li className="text-gray-400">
                Lun - Ven: 9h00 - 18h00
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} JYA. Tous droits réservés.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-gray-400 hover:text-yellow-500 text-sm transition-colors">
                Mentions légales
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-500 text-sm transition-colors">
                Politique de confidentialité
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-500 text-sm transition-colors">
                CGU
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
